import { useEffect } from 'react';

import { BookOutlined, CheckCircleFilled, DeploymentUnitOutlined, InfoCircleOutlined, LoginOutlined, PlayCircleFilled } from '@ant-design/icons';
import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';

const CStatus = ({ status }) => {
  if (status === 'init') return <span className={`status ${status}`}><InfoCircleOutlined /></span>;
  else if (status === 'opened') return <span className={`status ${status}`}><LoginOutlined /></span>;
  else if (status === 'playing') return <span className={`status ${status}`}><PlayCircleFilled /></span>;
  else if (status === 'finished') return <span className={`status ${status}`}><CheckCircleFilled /></span>;
  else return null;

}

const CompetitionsList = ({ lang, competitions, classes, onCompetitionClick }) => {

  // Registro en Google Analytics
  useEffect(() => {
    recordPageGA('/competitions-list');
  }, []);

  const handleClassClick = (aComp) => {
    onCompetitionClick(aComp);
  }

  if (competitions && competitions.length > 0 && classes && classes.length > 0) {
    return (
      <section className="classes-list">
        <ul className="class-items">
          {competitions.map((aComp) => {
            const cExers = aComp.exercises;
            const theClass = classes.find(aC => aC.id == aComp.class);

            if (aComp && theClass) {
              return <li key={aComp.id} className="class-item" onClick={() => { handleClassClick(aComp) }}>
                <DeploymentUnitOutlined className="class-icon" />
                <div className="class-info">
                  <strong>{aComp.name}</strong>
                  <div className="class-code">
                    <CStatus status={aComp.status} /> {t(lang, 'class')}: {theClass.name} - {cExers.length} {t(lang, 'challenges')}
                  </div>
                </div>
              </li>;
            }
            else return null;
          })}
        </ul>
      </section>
    );
  } else return null;
};

export default CompetitionsList;